module.exports = __webpack_public_path__ + "img/SEC.acb9ceab.png";